import React from 'react';
import { Box, SxProps } from '@mui/material';
import { Info } from '@mui/icons-material';
import { TooltipStyled } from './tooltip-container.styles';
interface TooltipsProps {
  tooltip?: string | JSX.Element;
  children: React.ReactNode;
  sx?: SxProps;
}
export const TooltipContainer = (props: TooltipsProps): JSX.Element => {
  const { tooltip, children, sx } = props;

  return (
    <Box sx={{ position: 'relative', width: '100%', ...sx }}>
      {tooltip && (
        <TooltipStyled title={tooltip}>
          <Info color='disabled' />
        </TooltipStyled>
      )}

      {children}
    </Box>
  );
};
